var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { WebMercatorViewport } from "react-map-gl";
import { theme } from "@gw/theming";
export var isOutOfMaxBounds = function (nextSW, nextNE, maxBounds) {
    var _a = maxBounds[0], maxSWLng = _a[0], maxSWLat = _a[1], _b = maxBounds[1], maxNELng = _b[0], maxNELat = _b[1];
    var nextSWLng = nextSW[0], nextSWLat = nextSW[1];
    var nextNELng = nextNE[0], nextNELat = nextNE[1];
    return (nextSWLng < maxSWLng ||
        nextSWLat < maxSWLat ||
        nextNELng > maxNELng ||
        nextNELat > maxNELat);
};
export var getCoordinatesBounds = function (farmers) {
    var coordinates = farmers.reduce(function (acc, farmer) {
        var _a = farmer.location.coordinates, lat = _a[0], lng = _a[1];
        return __assign(__assign({}, acc), { lat: __spreadArray(__spreadArray([], acc.lat), [lat]), lng: __spreadArray(__spreadArray([], acc.lng), [lng]) });
    }, {
        lat: [],
        lng: [],
    });
    return [
        [Math.min.apply(Math, coordinates.lng), Math.min.apply(Math, coordinates.lat)],
        [Math.max.apply(Math, coordinates.lng), Math.max.apply(Math, coordinates.lat)],
    ];
};
export var fitMarkersOnMap = function (width, height, isMobile, maxBounds) {
    var boundsOptions = {
        padding: 100,
        maxZoom: 8,
    };
    var isMobilePortrait = window.innerWidth <= parseInt(theme.responsive.mobile_md);
    if (isMobile && isMobilePortrait) {
        boundsOptions = {
            padding: {
                top: 50,
                left: 50,
                bottom: 250,
                right: 50,
            },
        };
    }
    return new WebMercatorViewport({
        width: width,
        height: height,
    }).fitBounds(maxBounds, boundsOptions);
};
export var filterFarmersOnNewViewport = function (farmers, newSouthWest, newNorthEast) {
    var nextSWLng = newSouthWest[0], nextSWLat = newSouthWest[1];
    var nextNELng = newNorthEast[0], nextNELat = newNorthEast[1];
    return farmers.map(function (farmer) {
        var _a = farmer.location.coordinates, lat = _a[0], lng = _a[1];
        return __assign(__assign({}, farmer), { isVisible: lng > nextSWLng &&
                lng < nextNELng &&
                lat > nextSWLat &&
                lat < nextNELat });
    });
};
export var getEdgesCoordinates = function (viewport) {
    var merc = new WebMercatorViewport(viewport);
    return {
        southWest: merc.unproject([0, viewport.height]),
        northEast: merc.unproject([viewport.width, 0]),
    };
};
//# sourceMappingURL=map.js.map